<div class="d-flex h-100 align-items-stretch">
    <div class="h-100 flex-grow-1 d-flex align-items-stretch">
        <div class="flex-grow-1 w-100 h-100" style="position:relative;">
            <div id="map-container-02" style="width:100%;height:100%;position:relative;"></div>
        </div>
    </div>

    <div class="d-flex flex-column align-items-stretch h-100 p-2">
        <div class="bg-light p-2 d-flex align-items-center justify-content-between"
            style="min-width: 200px;">
            <div class="h6 mb-0">
                <i class="mdi mdi-history"></i>
                <span class="ml-1">운행이력</span>
            </div>
            <div class="">
                <button type="button" class="btn btn-sm btn-info"
                    (click)="clickCancel()">
                    <i class="fas fa-times"></i>
                    <span class="ml-1">닫기</span>
                </button>
            </div>
        </div>

        <div class="flex-grow-1 overflow-hidden border-bottom"
            [class.h-40]="selectedTripInfo">
            <div class="h-100 overflow-auto">
                <ul class="list-group" style="min-width:300px;">
                    <ng-container *ngFor="let item of listTripInfo;index as idx;">
                        <li class="list-group-item list-group-item-action px-2"
                            [class.list-group-item-dark]="item.selected === true">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="h5 mb-0">
                                    {{item.dtgDriverNm || '-'}}
                                </div>
                                <div class="">
                                    <div class="form-check form-check-inline mr-0">
                                        <input type="checkbox" class="form-check-input"
                                            [(ngModel)]="item.selected"
                                            (ngModelChange)="changeTripInfoSelect($event,idx,item.fvmsTripCnt)">
                                    </div>
                                </div>
                            </div>
                            <div class="mt-2 small"
                                [class.text-muted]="item.selected === false">
                                <span>
                                    {{(item.dtgDistAccumulTo - item.dtgDistAccumulFrom) | filterDist | number:'0.0-3'}} Km 운행
                                </span>
                                <span>
                                    {{item.dtgRegDtDuration | filterSecToTime}} 소요
                                </span>
                            </div>
                            <div class="d-flex align-items-center mt-3">
                                <span class="fa-stack">
                                    <i class="fas fa-circle fa-stack-2x text-secondary"></i>
                                    <i class="fas fa-power-off fa-stack-1x fa-inverse"></i>
                                </span>
                                <div class="small ml-2 flex-grow-1"
                                    [class.text-muted]="item.selected === false">
                                    <div class="text-truncate">
                                        {{item.dtgGpsAddrTo}}
                                    </div>
                                    <div>
                                        {{item.dtgRegDtTo | date:'yyyy-MM-dd HH:mm:ss' || '-'}}
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-center my-2">
                                <i class="fas fa-ellipsis-v text-muted"></i>
                            </div>
                            <div class="d-flex align-items-center">
                                <span class="fa-stack">
                                    <i class="fas fa-circle fa-stack-2x text-success"></i>
                                    <i class="fas fa-power-off fa-stack-1x fa-inverse"></i>
                                </span>
                                <div class="small text-muted ml-2 flex-grow-1"
                                    [class.text-muted]="item.selected === false">
                                    <div class="text-truncate">
                                        {{item.dtgGpsAddrFrom}}
                                    </div>
                                    <div>
                                        {{item.dtgRegDtFrom | date:'yyyy-MM-dd HH:mm:ss' || '-'}}
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ng-container>
                </ul>
                <!-- <ul class="fa-ul fvms-timeline mt-3 mb-0" *ngFor="let item of listTripInfo;index as idx;">
                    <li class="fvms-timeline-item">
                        <span class="fa-li fa-stack">
                            <i class="fas fa-circle fa-stack-2x text-secondary"></i>
                            <i class="fas fa-power-off fa-stack-1x fa-inverse"></i>
                        </span>
                        <div class="fvms-timeline-item-body">
                            <div class="text-muted">
                                {{item.dtgGpsAddrTo}}
                            </div>
                            <div class="small mt-1 text-right">
                                <i class="far fa-clock fa-fw"></i>
                                <span class="ml-1">
                                    {{item.dtgRegDtTo | date:'yyyy-MM-dd HH:mm:ss' || '-'}}
                                </span>
                            </div>
                            <h5 class="mb-0 mt-1">
                                {{item.dtgDriverNm || '-'}}
                            </h5>
                            <div class="w-100 d-flex justify-content-between align-items-center mt-1">
                                <div>
                                    <span>
                                        {{(item.dtgDistAccumulTo - item.dtgDistAccumulFrom) | filterDist | number:'0.0-3'}} Km 운행
                                    </span>
                                    <span>
                                        {{item.dtgRegDtDuration | filterSecToTime}} 소요
                                    </span>
                                </div>
                                <div class="form-check form-check-inline mr-0">
                                    <input type="checkbox" class="form-check-input"
                                        [(ngModel)]="item.selected"
                                        (ngModelChange)="changeTripInfoSelect($event,idx,item.fvmsTripCnt)">
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="fvms-timeline-item">
                        <span class="fa-li fa-stack">
                            <i class="fas fa-circle fa-stack-2x text-success"></i>
                            <i class="fas fa-power-off fa-stack-1x fa-inverse"></i>
                        </span>
                        <div class="fvms-timeline-item-body">
                            <div class="text-muted">
                                {{item.dtgGpsAddrFrom}}
                            </div>
                            <div class="small mt-1 text-right">
                                <i class="far fa-clock fa-fw"></i>
                                <span class="ml-1">
                                    {{item.dtgRegDtFrom | date:'yyyy-MM-dd HH:mm:ss' || '-'}}
                                </span>
                            </div>
                        </div>
                    </li>
                </ul> -->

                <div class="mt-3 text-center" *ngIf="!listTripInfo">
                    운행 이력이 없습니다
                </div>
            </div>
        </div>

        <div class="mt-3">
            <table class="table table-sm mb-0">
                <thead>
                    <tr>
                        <td colspan="2" class="bg-light text-center">
                            당시정보
                        </td>
                    </tr>
                </thead>
                <tbody class="small">
                    <tr>
                        <td class="text-muted">
                            평균속도
                        </td>
                        <td class="text-right">
                            {{avgSpeed}} km/h
                        </td>
                    </tr>
                    <tr>
                        <td class="text-muted">
                            운행거리
                        </td>
                        <td class="text-right">
                            {{sumDist}} km
                        </td>
                    </tr>
                    <tr>
                        <td class="text-muted">
                            운행시간
                        </td>
                        <td class="text-right">
                            {{sumDuration | filterSecToTime}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="mt-3 overflow-hidden"
            [class.h-40]="selectedTripInfo"
            [hidden]="!selectedTripInfo || !selectedTripInfo.listDriveHis"
            style="min-height: 45px;">
            <div class="h-100 overflow-auto">
                <table class="table table-sm table-hover mb-0 small">
                    <thead>
                        <tr class="text-center">
                            <th>
                                운행일시
                            </th>
                            <th>
                                상태
                            </th>
                            <th>
                                속도<br>
                                (km/h)
                            </th>
                            <th>
                                누적거리<br>
                                (km)
                            </th>
                            <th>
                                주소
                            </th>
                        </tr>
                    </thead>
                    <tbody class="" *ngIf="selectedTripInfo && selectedTripInfo.listDriveHis">
                        <tr role="button" *ngFor="let item of selectedTripInfo.listDriveHis;let idx = index;"
                            [class.bg-light]="item.selected"
                            (mouseover)="showMarkerDriveHis(idx,item)"
                            (mouseout)="hideMarkerDriveHis()">
                            <td>
                                {{item.dtgRegDt}}
                            </td>
                            <td [ngSwitch]="item.dtgKeyonYn">
                                <span *ngSwitchCase="'1'">On</span>
                                <span *ngSwitchCase="'0'">Off</span>
                            </td>
                            <td class="text-right">
                                {{item.dtgSpeed | number:'1.0-0'}}
                            </td>
                            <td class="text-right">
                                {{item.dtgDistAccumul | filterDist | number:'0.0'}}
                            </td>
                            <td class="">
                                <div class="text-truncate" style="max-width: 160px;">
                                    {{item.dtgGpsAddr}}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>